// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eTk26j {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: var(--current-grid-gutter, 16px);
  width: 100%;
  height: 100%;
}

.BVrNo9 {
  padding: var(--spacing-3, 16px) !important;
  background-color: var(--background-white) !important;
}

.EIeLCv {
  grid-column: span 4;
  display: flex;
  flex-direction: column;
  gap: var(--current-grid-gutter, 16px);

  .pB8HlU {
    height: 200px;
    width: 100%;
    border-radius: 9px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: start;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    h3,
    button {
      position: relative;
      z-index: 2;
    }

    h3 {
      color: var(--image-text-color);
      font-weight: var(--font-weight-semibold);

      small {
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-regular);
        line-height: var(--line-height-160);
        margin-top: var(--spacing-0-5, 4px);
        display: block;
      }
    }
    button {
      margin-top: auto;
    }
  }

  .wWJdwv {
    flex-grow: 1;

    .cVlKyQ {
      margin-bottom: calc(var(--spacing-3, 24px));
    }

    .jsAyMp {
      h3 {
        font-weight: var(--font-weight-regular);
      }
    }

    .Rj8ze4 {
      list-style: none;
      padding: 0;
      margin: 0;
      font-size: var(--font-size-md);

      li {
        display: flex;
        gap: var(--spacing-2, 16px);

        p {
          margin-bottom: 0;
        }
      }
    }

    .VcVzdi {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-wrap: wrap;
      padding-top: var(--spacing-3, 24px);
      padding-bottom: var(--spacing-3, 24px);
      gap: var(--spacing-1-5, 8px);
    }
  }
}

.JlQylO {
  grid-column: span 8;
  display: flex;
  flex-direction: column;

  > div {
    flex-grow: 1;
  }

  .KkwCjn {
    display: inline-block;
    color: var(--brand-tr-orange);
    border-bottom: 2px solid var(--brand-tr-orange);
    padding-bottom: var(--spacing-1, 8px);
    padding-left: var(--spacing-1, 8px);
    padding-right: var(--spacing-1, 8px);
    margin-bottom: 0;
    font-weight: var(--font-weight-semibold);
  }

  .cVlKyQ {
    margin-top: 0;
    margin-bottom: var(--spacing-3, 24px);
  }
}

.DHehkq {
  font-size: var(--font-size-md);
  font-weight: 700;
  text-align: left;
  line-height: 1;

  &.Ks7OJV {
    font-size: var(--font-size-lg);
  }

  &.svzMgD {
    font-weight: var(--font-weight-semibold);
  }
}

.AbayyI {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: auto;
  width: var(--font-size-3xl, 32px);
  height: var(--font-size-3xl, 32px);
  background: var(--product-card-icon-container-bg);
  border-radius: 50%;
  flex-shrink: 0;
}

.cVlKyQ {
  border-top-color: var(--separator-color);
  margin-left: calc(var(--spacing-3, 16px) * -1);
  margin-right: calc(var(--spacing-3, 16px) * -1);
  margin-top: var(--spacing-2, 16px);
  margin-bottom: var(--spacing-2, 16px);
}

/* Responsive styles */
@media (max-width: 768px) {
  .EIeLCv,
  .JlQylO {
    grid-column: span 12;
  }

  .oJmvMx {
    flex-direction: column;
  }
}

.ikD9XZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100% - var(--spacing-4, 24px));
  gap: var(--spacing-4, 24px);

  > * {
    margin: 0;
  }

  .AbayyI {
    width: 72px;
    height: 72px;
    background: var(--surface-primary-subtle);
    border-radius: 50%;
    flex-shrink: 0;

    img,
    svg {
      filter: var(--primary-orange-filter);
    }
  }

  h4 {
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-semibold);
    text-align: center;

    small {
      margin-top: var(--spacing-1, 8px);
      display: block;
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-regular);
      line-height: var(--line-height-180);
      max-width: 300px;
    }
  }
}

.rqB2Fn {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  padding: 0;
  margin: 0;
  margin-top: var(--spacing-3, 24px);

  li {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-1, 8px);
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-2, 16px);
    background-color: var(--background-alt);
    .b5vg5O {
      font-size: var(--font-size-md);
      min-width: 24px;
      width: calc(100% / 3);
      text-align: center;
    }

    .R_uT0o {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 24px;
      width: 24px;
    }

    .DiU4J6 {
      cursor: pointer;
    }

    span {
      &:first-of-type {
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-semibold);
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100% / 3);
      }

      &._Je6IW {
        font-size: var(--font-size-sm);
        min-width: 150px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-right: auto;

        img,
        svg {
          visibility: hidden;
          margin-left: var(--spacing-0-5, 4px);
          margin-bottom: 0px;
          width: 16px;
          height: 16px;
        }

        &::before {
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: var(--spacing-1, 8px);
          flex-shrink: 0;
        }

        &.WfmjIc {
          color: var(--status-success);
          &::before {
            background-color: var(--status-success);
            box-shadow: 0 0 4px 1px var(--status-success);
          }
        }
        &.Ks7OJV {
          color: var(--status-info);
          img,
          svg {
            visibility: visible;
            filter: var(--status-info-filter);
          }
          &::before {
            background-color: var(--status-info);
            box-shadow: 0 0 4px 1px var(--status-info);
          }
        }
        &.yN5gdR {
          color: var(--status-error);
          &::before {
            background-color: var(--status-error);
            box-shadow: 0 0 4px 1px var(--status-error);
          }
        }
      }
    }
  }
}

.IRJb7J {
  border: none !important;
  background-color: transparent !important;
  flex-grow: 0;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/contabilidade-digital/src/pages/ContabilidadeDigitalDasboard/ContabilidadeDigitalDasboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;;EAErC;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;;IAElB;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,UAAU;IACZ;;IAEA;;MAEE,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,8BAA8B;MAC9B,wCAAwC;;MAExC;QACE,8BAA8B;QAC9B,uCAAuC;QACvC,mCAAmC;QACnC,mCAAmC;QACnC,cAAc;MAChB;IACF;IACA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,YAAY;;IAEZ;MACE,2CAA2C;IAC7C;;IAEA;MACE;QACE,uCAAuC;MACzC;IACF;;IAEA;MACE,gBAAgB;MAChB,UAAU;MACV,SAAS;MACT,8BAA8B;;MAE9B;QACE,aAAa;QACb,2BAA2B;;QAE3B;UACE,gBAAgB;QAClB;MACF;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,eAAe;MACf,mCAAmC;MACnC,sCAAsC;MACtC,4BAA4B;IAC9B;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;;EAEtB;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,+CAA+C;IAC/C,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;IACpC,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;;EAEd;IACE,8BAA8B;EAChC;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;EAClC,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,+CAA+C;EAC/C,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE;;IAEE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,2BAA2B;;EAE3B;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;;IAEd;;MAEE,oCAAoC;IACtC;EACF;;EAEA;IACE,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;;IAElB;MACE,iCAAiC;MACjC,cAAc;MACd,8BAA8B;MAC9B,uCAAuC;MACvC,mCAAmC;MACnC,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,kCAAkC;;EAElC;IACE,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;IAC/B,uCAAuC;IACvC;MACE,8BAA8B;MAC9B,eAAe;MACf,qBAAqB;MACrB,kBAAkB;IACpB;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE;QACE,8BAA8B;QAC9B,wCAAwC;QACxC,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,qBAAqB;MACvB;;MAEA;QACE,8BAA8B;QAC9B,gBAAgB;QAChB,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,kBAAkB;;QAElB;;UAEE,kBAAkB;UAClB,oCAAoC;UACpC,kBAAkB;UAClB,WAAW;UACX,YAAY;QACd;;QAEA;UACE,WAAW;UACX,qBAAqB;UACrB,UAAU;UACV,WAAW;UACX,kBAAkB;UAClB,mCAAmC;UACnC,cAAc;QAChB;;QAEA;UACE,4BAA4B;UAC5B;YACE,uCAAuC;YACvC,6CAA6C;UAC/C;QACF;QACA;UACE,yBAAyB;UACzB;;YAEE,mBAAmB;YACnB,iCAAiC;UACnC;UACA;YACE,oCAAoC;YACpC,0CAA0C;UAC5C;QACF;QACA;UACE,0BAA0B;UAC1B;YACE,qCAAqC;YACrC,2CAA2C;UAC7C;QACF;MACF;IACF;EACF;AACF;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".gridContainer {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: var(--current-grid-gutter, 16px);\n  width: 100%;\n  height: 100%;\n}\n\n.panelCard {\n  padding: var(--spacing-3, 16px) !important;\n  background-color: var(--background-white) !important;\n}\n\n.firstPanel {\n  grid-column: span 4;\n  display: flex;\n  flex-direction: column;\n  gap: var(--current-grid-gutter, 16px);\n\n  .cardImage {\n    height: 200px;\n    width: 100%;\n    border-radius: 9px;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1;\n    }\n\n    h3,\n    button {\n      position: relative;\n      z-index: 2;\n    }\n\n    h3 {\n      color: var(--image-text-color);\n      font-weight: var(--font-weight-semibold);\n\n      small {\n        font-size: var(--font-size-md);\n        font-weight: var(--font-weight-regular);\n        line-height: var(--line-height-160);\n        margin-top: var(--spacing-0-5, 4px);\n        display: block;\n      }\n    }\n    button {\n      margin-top: auto;\n    }\n  }\n\n  .cardInfo {\n    flex-grow: 1;\n\n    .separator {\n      margin-bottom: calc(var(--spacing-3, 24px));\n    }\n\n    .cardInfoHeader {\n      h3 {\n        font-weight: var(--font-weight-regular);\n      }\n    }\n\n    .cardInfoList {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      font-size: var(--font-size-md);\n\n      li {\n        display: flex;\n        gap: var(--spacing-2, 16px);\n\n        p {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    .badgeContainer {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      flex-wrap: wrap;\n      padding-top: var(--spacing-3, 24px);\n      padding-bottom: var(--spacing-3, 24px);\n      gap: var(--spacing-1-5, 8px);\n    }\n  }\n}\n\n.secondPanel {\n  grid-column: span 8;\n  display: flex;\n  flex-direction: column;\n\n  > div {\n    flex-grow: 1;\n  }\n\n  .mainTitle {\n    display: inline-block;\n    color: var(--brand-tr-orange);\n    border-bottom: 2px solid var(--brand-tr-orange);\n    padding-bottom: var(--spacing-1, 8px);\n    padding-left: var(--spacing-1, 8px);\n    padding-right: var(--spacing-1, 8px);\n    margin-bottom: 0;\n    font-weight: var(--font-weight-semibold);\n  }\n\n  .separator {\n    margin-top: 0;\n    margin-bottom: var(--spacing-3, 24px);\n  }\n}\n\n.cardTitle {\n  font-size: var(--font-size-md);\n  font-weight: 700;\n  text-align: left;\n  line-height: 1;\n\n  &.info {\n    font-size: var(--font-size-lg);\n  }\n\n  &.semi {\n    font-weight: var(--font-weight-semibold);\n  }\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: auto;\n  width: var(--font-size-3xl, 32px);\n  height: var(--font-size-3xl, 32px);\n  background: var(--product-card-icon-container-bg);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.separator {\n  border-top-color: var(--separator-color);\n  margin-left: calc(var(--spacing-3, 16px) * -1);\n  margin-right: calc(var(--spacing-3, 16px) * -1);\n  margin-top: var(--spacing-2, 16px);\n  margin-bottom: var(--spacing-2, 16px);\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .firstPanel,\n  .secondPanel {\n    grid-column: span 12;\n  }\n\n  .actionsContainer {\n    flex-direction: column;\n  }\n}\n\n.emptyList {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: calc(100% - var(--spacing-4, 24px));\n  gap: var(--spacing-4, 24px);\n\n  > * {\n    margin: 0;\n  }\n\n  .iconContainer {\n    width: 72px;\n    height: 72px;\n    background: var(--surface-primary-subtle);\n    border-radius: 50%;\n    flex-shrink: 0;\n\n    img,\n    svg {\n      filter: var(--primary-orange-filter);\n    }\n  }\n\n  h4 {\n    font-size: var(--font-size-md);\n    font-weight: var(--font-weight-semibold);\n    text-align: center;\n\n    small {\n      margin-top: var(--spacing-1, 8px);\n      display: block;\n      font-size: var(--font-size-md);\n      font-weight: var(--font-weight-regular);\n      line-height: var(--line-height-180);\n      max-width: 300px;\n    }\n  }\n}\n\n.accountsList {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  padding: 0;\n  margin: 0;\n  margin-top: var(--spacing-3, 24px);\n\n  li {\n    display: flex;\n    flex-direction: row;\n    gap: var(--spacing-1, 8px);\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--spacing-2, 16px);\n    background-color: var(--background-alt);\n    .labelBalance {\n      font-size: var(--font-size-md);\n      min-width: 24px;\n      width: calc(100% / 3);\n      text-align: center;\n    }\n\n    .chevronIconWrapper {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 24px;\n      width: 24px;\n    }\n\n    .chevronIcon {\n      cursor: pointer;\n    }\n\n    span {\n      &:first-of-type {\n        font-size: var(--font-size-md);\n        font-weight: var(--font-weight-semibold);\n        min-width: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: calc(100% / 3);\n      }\n\n      &.statusWrapper {\n        font-size: var(--font-size-sm);\n        min-width: 150px;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        margin-right: auto;\n\n        img,\n        svg {\n          visibility: hidden;\n          margin-left: var(--spacing-0-5, 4px);\n          margin-bottom: 0px;\n          width: 16px;\n          height: 16px;\n        }\n\n        &::before {\n          content: '';\n          display: inline-block;\n          width: 6px;\n          height: 6px;\n          border-radius: 50%;\n          margin-right: var(--spacing-1, 8px);\n          flex-shrink: 0;\n        }\n\n        &.success {\n          color: var(--status-success);\n          &::before {\n            background-color: var(--status-success);\n            box-shadow: 0 0 4px 1px var(--status-success);\n          }\n        }\n        &.info {\n          color: var(--status-info);\n          img,\n          svg {\n            visibility: visible;\n            filter: var(--status-info-filter);\n          }\n          &::before {\n            background-color: var(--status-info);\n            box-shadow: 0 0 4px 1px var(--status-info);\n          }\n        }\n        &.error {\n          color: var(--status-error);\n          &::before {\n            background-color: var(--status-error);\n            box-shadow: 0 0 4px 1px var(--status-error);\n          }\n        }\n      }\n    }\n  }\n}\n\n.avatar {\n  border: none !important;\n  background-color: transparent !important;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `eTk26j`,
	"panelCard": `BVrNo9`,
	"firstPanel": `EIeLCv`,
	"cardImage": `pB8HlU`,
	"cardInfo": `wWJdwv`,
	"separator": `cVlKyQ`,
	"cardInfoHeader": `jsAyMp`,
	"cardInfoList": `Rj8ze4`,
	"badgeContainer": `VcVzdi`,
	"secondPanel": `JlQylO`,
	"mainTitle": `KkwCjn`,
	"cardTitle": `DHehkq`,
	"info": `Ks7OJV`,
	"semi": `svzMgD`,
	"iconContainer": `AbayyI`,
	"actionsContainer": `oJmvMx`,
	"emptyList": `ikD9XZ`,
	"accountsList": `rqB2Fn`,
	"labelBalance": `b5vg5O`,
	"chevronIconWrapper": `R_uT0o`,
	"chevronIcon": `DiU4J6`,
	"statusWrapper": `_Je6IW`,
	"success": `WfmjIc`,
	"error": `yN5gdR`,
	"avatar": `IRJb7J`
};
module.exports = ___CSS_LOADER_EXPORT___;
